// extracted by mini-css-extract-plugin
module.exports = {"BundlesContainer":"Bundles_BundlesContainer__1EWvg","Link":"Bundles_Link__2msNw"};